import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "../VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  VOUCHER_INVOICE_TYPE,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { formatMoney, formatPrintPatientCodeSuffix, getDateTime, hideMiddleDigits } from "app/common/LocalFunction";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormApi = ({
  componentRef,
  dataVoucherFee,
  initialPatient,
  staffRevenues = [],
}) => {
  console.log("dataVoucherFee", dataVoucherFee);
  console.log("staffRevenues", staffRevenues);
  const totalValue =
    dataVoucherFee?.items?.length > 0 &&
    dataVoucherFee?.items?.reduce(
      (acc, curr) => {
        return {
          totalQuantity: acc.totalQuantity + (curr?.quantity || 0),
          totalPrice:
            acc.totalPrice + (curr?.price || 0) * (curr?.quantity || 0),
          totalAmount:
            acc.totalAmount + curr?.invoiceItem?.subAmountActuallyPaid,
          totalPaid: acc.totalPaid + curr?.invoiceItem?.subTotalBillPatientPaid,
          totalDebit:
            acc.totalDebit +
            (curr?.invoiceItem?.subAmountActuallyPaid -
              curr?.invoiceItem?.subTotalBillPatientPaid),
        };
      },
      {
        totalQuantity: 0,
        totalAmount: 0,
        totalPrice: 0,
        totalPaid: 0,
        totalDebit: 0,
      }
    );
  const namesText = Array.isArray(staffRevenues)
    ? staffRevenues?.map((item) => item?.staff?.staffName).join(" ; ")
    : "Không rõ";

  return (
    <PrintCommon ref={componentRef} marginPage="4mm" hidden={false}>
      <header className="printHeader w-100 flex justify-between print-voucher">
        <table className="table-layout-fixed">
          <div className="wraper-print">
            <div className="container-print">
              <VoucherPrintOrgHeading department={dataVoucherFee?.department} />
              <VoucherPrintOrgAddress department={dataVoucherFee?.department} />

              <div className="mt-5 text-center">
                <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                  PHIẾU THU
                </h4>
                <div className="center">
                  {getDateTime(dataVoucherFee?.voucherDate, "", "DD/MM/YYYY")}
                </div>
              </div>
              <table
                className="info-print"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "30%",
                        fontWeight: "bold",
                        padding: "4px 0",
                      }}
                    >
                      KH:
                    </td>
                    <td
                      style={{
                        width: "70%",
                        padding: "4px 0",
                        fontWeight: "bold",
                      }}
                    >
                      {dataVoucherFee?.patient?.displayName || ""}{" "}
                      {formatPrintPatientCodeSuffix(dataVoucherFee?.patient, initialPatient)}{" "}
                      {dataVoucherFee?.patient?.phoneNumber
                        ? `- ${hideMiddleDigits(dataVoucherFee?.patient?.phoneNumber)}`
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Tư vấn viên:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {namesText}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Thu ngân:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {" "}
                      {dataVoucherFee?.accountant?.staffName || "Không rõ"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Số phiếu:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {dataVoucherFee?.code || "Chưa có mã"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table-print">
                <thead className="thead-print">
                  <tr>
                    <th width="10%">SL</th>

                    <th>Đ.Giá</th>
                    <th>KM</th>
                    <th>Thành tiền</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {dataVoucherFee?.items?.length > 0 ? (
                    dataVoucherFee?.items?.map((it, index) => (
                      <React.Fragment key={it.id || index}>
                        <tr className="no-border">
                          <td colSpan={4} className="service-name-td">
                            {it?.invoiceItem?.invoiceItemRegisterName
                              ? it?.invoiceItem?.invoiceItemRegisterName
                              : it?.invoiceItem?.invoiceItemName}
                          </td>
                        </tr>
                        <tr>
                          <td>{it?.invoiceItem?.quantity || 0}</td>
                          <td>{formatMoney(it?.invoiceItem?.currentFee)}</td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.discount +
                              it?.invoiceItem?.allocateDiscount || 0
                            )}
                          </td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.subAmountActuallyPaid || 0
                            )}
                          </td>
                        </tr>
                        {it?.treatmentPlanCard && (
                          <>
                            {/* Dịch vụ trong liệu trình */}
                            {Array.isArray(
                              it.treatmentPlanCard.paServiceRegister
                            ) &&
                              it.treatmentPlanCard.paServiceRegister.map(
                                (srv, i) => (
                                  <tr key={`srv-${srv.id || i}`}>
                                    <td
                                      colSpan={4}
                                      style={{
                                        paddingLeft: "24px",
                                        fontStyle: "italic",
                                        fontSize: "9px",
                                      }}
                                    >
                                      (SL: {srv?.quantity || 1}){" "}
                                      {srv?.service?.name || "Dịch vụ không rõ"}
                                    </td>
                                  </tr>
                                )
                              )}

                            {/* Thuốc trong liệu trình */}
                            {Array.isArray(it.treatmentPlanCard.drugs) &&
                              it.treatmentPlanCard.drugs.map((drug, j) => (
                                <tr key={`drug-${drug.id || j}`}>
                                  <td
                                    colSpan={4}
                                    style={{
                                      paddingLeft: "24px",
                                      fontStyle: "italic",
                                      fontSize: "10px",
                                    }}
                                  >
                                    (SL: {drug?.quantity || 1}){" "}
                                    {drug?.drug?.name || "Sản phẩm không rõ"}
                                  </td>
                                </tr>
                              ))}
                          </>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <table className="summary-table">
                <tbody>
                  <tr>
                    <td className="label-print">Tổng số lượng :</td>
                    <td className="value-print">
                      {dataVoucherFee?.items?.length || 0}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Tiền hàng :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(dataVoucherFee?.grossAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Tổng tiền (VNĐ):</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(dataVoucherFee?.actuallyTotalAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Đã thanh toán :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(dataVoucherFee?.amountPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Khách hàng trả :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(dataVoucherFee?.customerPaidAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Còn nợ :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(dataVoucherFee?.remainingDebt)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Ghi chú :</td>
                    <td className="value-print">
                      {dataVoucherFee?.note || "Không có ghi chú"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div style={{ textAlign: "center", fontSize: "12px" }}>
                <span>Chữ ký khách hàng</span>
                <div style={{ height: "90px" }}></div>
              </div>

              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    textTransform: "uppercase",
                  }}
                >
                  <span>
                    Quý khách vui lòng kiểm tra dịch vụ/sản phẩm trước khi rời
                    khỏi quầy. Sản phẩm sẽ không được đổi trả. Khi khách hàng
                    tự ý ngưng dịch vụ sẽ không được hoàn lại tiền mà sẽ được
                    tư vấn chuyển sang dịch vụ khác. Dịch vụ có thời hạn sử
                    dụng trong vòng 12 tháng kể từ thời điểm thu tiền và xuất
                    hóa đơn. Xin cảm ơn Quý khách và hẹn gặp lại !!!
                  </span>
                </div>
                <div>
                  <VoucherPrintDepartmentFooter department={dataVoucherFee?.department} style={{ marginTop: "12px", fontSize: "14px" }} />
                  <br />
                  {/* <span style={{ color: "gray", fontWeight: "bold" }}>
                    1136000485
                  </span> */}
                  <QrSurveySection patient={dataVoucherFee?.patient} />
                </div>
              </div>
            </div>
          </div>
        </table>
      </header>
    </PrintCommon>
  );
};

export default memo(PrintFormApi);
